<section class="breadcrumb-section">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="breadcrumb-title">
					<h1>Anti Ragging Squad</h1>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="section-lg std-scholarship">
	<div class="container">
		<div class="table-responsive">
			<table class="table table-bordered text-center tbl_custom">
				<thead>
					<tr>
						<th>Sr. No.</th>
						<th>Name Of the Member</th>
					</tr>
				</thead>
				<tbody>

					<tr>
						<td>1</td>
						<td>Mr. Pankaj Pethe</td>
					</tr>
					<tr>
						<td>2</td>
						<td>Mr. Vishal Dhabalia</td>
					</tr>
					<tr>
						<td>3</td>
						<td>Manmeet Singh Bedi</td>
					</tr>
					<tr>
						<td>4</td>
						<td>Deepa Munot</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</section>